export default "__VITE_ASSET__BcYi1S29__"